import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy-900 px-4 pb-32 pt-6 text-center sm:pb-36" data-id="element-168" data-mp="19j53j40hsmi0">
      <div className="mx-auto w-full max-w-3xl border-t border-white/10 pt-8" data-id="element-169" data-mp="206rfr8n93coj">
        <p className="font-display text-base font-black uppercase tracking-wide text-white" data-id="element-170" data-mp="2f53d7hig6pgr">
          Aligner Control System™
        </p>
        <p className="mt-2 text-sm leading-relaxed text-navy-200" data-id="element-171" data-mp="2a6ib1cjmxvpo">
          Organize your aligner workflow. Review your cases. Follow a structured
          system.
        </p>
        <p className="mt-3 text-sm font-semibold text-navy-100" data-id="element-172" data-mp="1hie3smlf1akv">
          Created by Dr. Karito
        </p>
        <p className="mt-4 text-xs leading-relaxed text-navy-300" data-id="element-173" data-mp="1w7iocafonqw5">
          The materials are educational and do not replace professional
          education, diagnosis, clinical judgment, manufacturer instructions, or
          applicable regulations.
        </p>
        <p className="mt-4 text-xs text-navy-400" data-id="element-174" data-mp="yr3do7nil1u1">
          © 2026 · ALIGNER CONTROL SYSTEM™ All rights reserved.
        </p>
      </div>
    </footer>;
}